import WebWorkerDB from "./webworker-db";

export function get_db(db_name: string, store_name: string): Promise<unknown> {
  return new Promise((resolve: (value?: unknown) => void) => {
    const db_worker: WebWorkerDB = new WebWorkerDB();
    db_worker.postMessage(JSON.stringify([0, db_name, store_name]));

    const listener: Function = (e: MessageEvent): void => {
      db_worker.removeEventListener("message", listener);
      try {
        resolve(JSON.parse(e.data));
      } catch {
        resolve(e.data);
      }
    };

    db_worker.addEventListener("message", listener);
  });
}

export function set_db(db_name: string, store_name: string, value: any) {
  const db_worker: WebWorkerDB = new WebWorkerDB();
  db_worker.postMessage(JSON.stringify([1, db_name, store_name, value]));
}
